import { useSelector } from 'react-redux';
import * as HistoryService from '../../base/historyService';
import { AssessmentRoute } from '../AssessmentPage';
import * as Selectors from '../selectors';
import { EAssessmentSubpage } from '../types';
import CFQEvaluationSubpage from './CFQEvaluationSubpage';
import CFQIntro from './CFQIntro';
import CFQQuestionSection from './CFQQuestionSection';
import './CFQSubpage.scss';

export default function CFQSubpage() {
  const cfqStarted = useSelector(Selectors.isCFQStarted);
  const subpage = useSelector(Selectors.getCurrentSubpage);
  if (subpage === EAssessmentSubpage.CFQEvaluation) {
    return <CFQEvaluationSubpage />;
  } else if (subpage === EAssessmentSubpage.CFQ) {
    return <div className="cfq-subpage">{cfqStarted ? <CFQQuestionSection /> : <CFQIntro />}</div>;
  }
  HistoryService.redirectInternal(AssessmentRoute);
}
